import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ViewToggleOption } from "../card-types";

@Component({
  selector: "card-select",
  templateUrl: "./card-select.component.html",
  styleUrls: ["../../dashboard-section.scss", "../../dashboard-section-v2.scss"],
  styles: [":host { display: contents; }"],
})
export class CardSelectComponent {
  @Input() label: string;
  @Input() options: ViewToggleOption[] = [];
  @Input() value: string;
  @Output() valueChange = new EventEmitter<string>();

  onChange(event: Event) {
    this.valueChange.emit((event.target as HTMLSelectElement).value);
  }
}
